import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FarmItem = _resolveComponent("FarmItem")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["FarmSliderItem farm-slider-item", { 'is--visible': _ctx.visible }])
  }, [
    _createVNode(_component_FarmItem, {
      farm: _ctx.farmData,
      "for-slider": "",
      "force-load-farm-image": "",
      class: "farm-slider-item__farm"
    }, null, 8, ["farm"]),
    _renderSlot(_ctx.$slots, "default", {}, undefined, true)
  ], 2))
}